import React from 'react';

const RankTableRowFilters = (props) => {

    function makeIcon() {
        return require(`assets/img/icons/ranks/${props.rank.icon}/${props.rank.icon}-${props.rank.color}.svg`);
    }

    return (
        <tr>
            <div className="custom-control custom-control-alternative custom-checkbox mb-3 my-4">
                <input
                    className="custom-control-input"
                    id={props.rank.id}
                    onChange={e => props.handleGroupSelected(e.target.checked, props.rank)}
                    checked={props.selected === true}
                    type="checkbox"
                />
                <label className="custom-control-label text-white" htmlFor={props.rank.id}>
                    <img
                        style={{marginRight: '0.5rem'}}
                        width={24}
                        height={24}
                        onClick={e => props.assignRank(e, props.rank)}
                        alt=""
                        src={makeIcon()}
                    />
                    {props.rank.title}
                </label>
            </div>
        </tr>
    )
};

export default RankTableRowFilters;